export interface Review {
  name: string;
  title: string;
  content: string;
  rating: number;
  reply: string;
  date: string;
}

export const reviews: Review[] = [
  {
    rating: 5,
    name: "ljkjen",
    title: "超級棒的冥想 app",
    content: "很多自訂模式，在任何場景都可以快速找到適合的功能，非常實用",
    reply: "感謝你的支持，對我們是很大的鼓勵！我們也會繼續努力讓 app 變得更好 - Yuji & Clarymind Team 🙌",
    date: "2024/6/24",
  },
  {
    rating: 5,
    name: "聞青",
    title: "台灣人創造的完美app",
    content: "人生最重要的就是時間，科技的進步隱含著科技巨頭利用人類注意力去創造更大的財富。 但是人們會越來越不快樂，因為用了太多社群媒體，這個app可以幫助你減少用手機的衝動，幫助你找回平靜的人生。 我是從臉書追蹤到作者，後來發現他出這款app，我覺得真的很棒，原本是用韓國的app，我認為也不錯，但是這款更完整而且更讓人放鬆！",
    reply: "非常感謝你的評論，對我們是很大的鼓勵！我們會持續讓 app 變得更好，也希望能幫助更多人找回平靜與注意力 - Yuji & Clarymind Team 🙌",
    date: "2024/8/12",
  },
  {
    rating: 5,
    name: "欸喔喔喔喔喔喔",
    title: "幫你找回現實生活的APP",
    content: "如果你每天忍不住一直滑社群媒體，又總是後悔自己不該這樣浪費時間 那其實不一定是你不夠有自制力，或許是缺了一個好工具，clarymind就是一個可以幫助你無痛減少手機使用時間的超棒工具！",
    reply: "非常感謝你的分享，對我們是很大的鼓勵！我們會持續開發與「專注」和「健康」相關的應用功能，歡迎持續關注我們的 Discord: https://discord.gg/H6McMYzJJJ - Yuji & Clarymind Team 🙌",
    date: "2024/8/17",
  },
  {
    rating: 5,
    name: "ValavalavalT",
    title: "Great app!",
    content: "Clarymind is great. I have been struggling two problems in my life: 1. My anxiety 2. My addiction to chase after dopamine Although I’ve been seeking professional help for these problems, I just couldn’t be happier to find an App thats able to help me with both (at the same time too!) 🥹 It doesn’t only save me time, and the anxiety that I was unconsciously taking in while scrolling Instagram Thank you Clarymind🤍 I look forward to more mindfulness with your development team",
    reply: "Thanks for sharing your stories! We’re so glad Clarymind is working for you. We’re committed to making the app better and appreciate your support!- Yuji & the Clarymind Team 🙇🏻",
    date: "2024/8/22",
  },
  {
    rating: 5,
    name: "CYH_write",
    title: "Great interface!",
    content: "Nice meditation music, easy to start meditation any time! The app locking function is surprisingly effective!",
    reply: "Thank you for your support! We hope you find it helpful, and we'll keep working to make the app even better! - Yuji & Clarymind Team 🙇🏻",
    date: "2024/7/10",
  },
  {
    rating: 5,
    name: "C.K. C.",
    title: "An App that everyone needs in 2024",
    content: "It’s so helpful.",
    reply: "Thank you for sharing your thoughts with us! Your kindness and support are what keep us going - Clarymind Team 🙇🏻",
    date: "2024/8/27",
  },
  {
    rating: 5,
    name: "DucklingChiu",
    title: "有效減少被手機分心的時間",
    content: "Clarymind藉由延長開啟社群軟體的時間，在等待的時間顯示一些值得反思的問題，有效讓我減少下意識尋求社交刺激的習慣。",
    reply: "感謝你和我們分享使用心得！ Clarymind 會繼續推出和健康、睡眠、專注相關的功能，在 Clarymind 的 Discord ，可以看到最新發佈的功能哦- Yuji & Clarymind Team 🙌",
    date: "2024/8/14",
  },
  {
    rating: 5,
    name: "pk had",
    title: "Great app!",
    content: "Clarymind is undoubtedly an app that everyone can use in modern society. When experiencing intense emotional fluctuations, you can use Clarymind's “Breath” feature to help calm your emotions. The app also offers various white noises, animal sounds, rain sounds, crackling fire sounds, and more, which are incredibly useful when trying to sleep at daytime during night shift!",
    reply: "Thank you for your support! We just launched Shado, and I hope you find it helpful too. We'll keep working to make the app even better! - Yuji & the Clarymind Team 🙇🏻",
    date: "2024/8/21",
  },
  {
    rating: 5,
    name: "Fanyaning",
    title: "「影侍」功能真的很讚！",
    content: "今天看到「影侍」功能上線， 真的忍不住想來留言， 這功能真的超棒， 把正念「停一下」的概念加進設計， 幫助使用者練習覺察到自己正要做什麼， 這個機制真的對於戒掉無意識的成癮行為很有幫助！",
    reply: "謝謝你和我們分享使用「影侍」的心得，對我們來說是很大的鼓勵！ （這也是我非常喜歡，並且每天使用的功能） 我們會持續開發與「專注」和「健康」相關的應用。如果有任何問題，除了 Discord 和寄信外，客服問題還可以聯絡官方 LINE 哦： https://go.clarymind.com/8rKFp6 　 - Yuji & Clarymind Team 🙌",
    date: "2024/8/24",
  },
  {
    rating: 5,
    name: "roceanw",
    title: "Great app",
    content: "It really works! Love it!",
    reply: "Thank you for sharing your thoughts with us! It means a lot to us! - Clarymind Team 🙇🏻",
    date: "2024/9/1",
  },
  {
    rating: 5,
    name: "qwerccrcfbvguvjcg",
    title: "Helped my phone addiction",
    content: "This rly helped with my phone addiction I just want to ask what is the use of the gems 很棒的App, 真的有在幫助我的手機成癮問題",
    reply: "感謝你的評論，對我們是很大的鼓勵！我們會持續讓 app 變得更好，也希望能幫助更多人找回平靜與注意力 - Clarymind Team 🙌",
    date: "2024/11/28",
  },
  {
    rating: 5,
    name: "kn4600",
    title: "Actually cute and thoughtful",
    content: "I am someone diagnosed with ADHD and have been looking into reducing my impulsive shopping habits and screen time as a new year resolution. I randomly found this app while scrolling social media and didn’t think much of it at first especially since I already had an app that was locking me out but I gave this one a try because admittedly, the visuals drew me in. But it was a nice surprise to find that not only was it very cute but it’s actually thoughtful in implementing the exercises and ways to block the apps. The only things I wish were present were options to make disabling the blocker harder since I have a habit of unlocking it indefinitely and then just never turning it back on again which I want to avoid… and also a student discount would have been nice but I do understand that this is an investment and it’s clear there was a lot of work put into this app. But the price is pretty steep for what it is worth, being completely honest",
    reply: "Thank you so much for your message. It means a lot to us! Have you tried the strict mode? In strict mode, you must enter your purpose every time you unlock your phone. The screen time guard will strictly review your reasons, and you can't exceed the daily limit you set. This mode might be helpful for you. Clarymind aims to build a personal health app beyond just screen time features. Whether it's addressing ADHD, impulsive shopping, or other health-related issues, feel free to share your ideas or feature requests at contact@clarymind.com. We're a small, dedicated team working full-time, releasing updates weekly. We hope to provide even more support for you💛 — Clarymind Team 🙌",
    date: "2025/1/15",
  },
  {
    rating: 5,
    name: "花栗薯泥",
    title: "有效，但收費滿高的",
    content: "如題，的確可以阻止手機的衝動，但個人只需要這個功能，其他功能都用不到的話會覺得滿貴的🥹",
    reply: "最近也有用戶詢問我們，有沒有打算推出「可使用功能較少」的其他訂閱方案。 我們內部其實花了不少時間討論過這個問題，現階段暫時不會有不同方案的價格，主要考量如下： Clarymind 長期願景是個人健康 App，功能種類預計會越來越多。依照目前的開發進度，Clarymind 每一個月會推 1-2 個新功能模組。 ・如果推出超過一個訂閱方案，每次單一功能模組上線，都要考慮該放在哪一個方案，而每個決定都很艱難 ・每多一種方案，都可能會增加新用戶理解 Clarymind 的門檻 ・對於已購買的舊戶，可能會有升級或降級的需求。然而 Apple 的訂單退換，開發者這邊無法百分之百掌控，可能會造成一些用戶困擾 我們也會繼續討論，或許未來會有其他適合的作法，可以滿足更多用戶的需求。 謝謝你的留言，我們很高興對你有幫助！ - Clarymind Team 🙇🏻",
    date: "2024/11/28",
  },
  {
    rating: 5,
    name: "KCITOR",
    title: "心得與建議",
    content: "剛用了付費版2-3天的心得，是我目前找到類似app來說最方便操作與符合需求的 1. 提升專注（螢幕使用時間）：覺得對於減少使用社群真的相較iPhone內建螢幕使用時間來說，有顯著的幫助，如果可以關掉app後，同時上鎖app覺得會更方便，目前關掉app後若沒有在此app上鎖，仍會計算成app的使用時間；另外希望能針對某些app打開前顯示使用次數，但非鎖定使用時間（例如Line是必用，但想在打開前看今天開了幾次） 2. 睡眠音樂的白噪音：頌缽很讚，希望能有更多類似的聲音例如：罄 3. 冥想正念：這功能無法使用，似乎故障了 4. 睡眠音樂的音樂：使用時間覺得找不太到自己想要的聲音就沒什麼在用 5. 每日自我肯定：這個功能不錯，也許可以設定每天自動推播，不然不太會主動點進去看 6. 設定：也許可以設定自動開關底部欄位功能 7. 呼吸練習：這個功能很讚，希望震動能夠調整大小，或者是能夠把震動變成短鈴聲或引導語，這樣就不要定要邊看螢幕才能做，每次使用的前導短片也許可以點選略過",
    reply: "太感謝您的心得與建議！！ 如果方便的話，可以寄信到 contact@clarymind.com 提供您的聯絡方式嗎，我們很希望可以解決您遇到的問題，和您釐清一些需求細節，並且在您建議的功能上線後，主動寄信通知。 先在這回答您遇到的問題： 1. 冥想正念：我們今天用所有測試機檢查，都可以正常播放，想和您確認無法使用的情境或設定🙏 2. 提升專注： - 我們是透過 iPhone 授權的螢幕使用時間來執行上鎖/解鎖，但 Clarymind 本身是不能取得任何使用數據的，故我們無法得知您是否還在使用社群 - 所以我們對應做的機制是，在「提升專注」頁面，會即時顯示目前解鎖中的社群，以及剩餘可使用時間。如果發覺已經不想使用社群了，便可以點選右方的方塊按鈕「⬛︎」來提早上鎖，就不會計入當日的使用時間計算了🙏 3. 自我肯定：目前支援在手機桌面設定自我肯定的 widget ，方便每天查看 （作法：在主畫面上，按住空白區域，直到畫面晃動 > 點一下左上角的「編輯」 > 選擇「加入小工具」 > 在搜尋欄位輸入「Clarymind」 > 點「加入小工具」．就完成囉！） 以上是快速回饋現況，您的建議我們正在討論中，如果您願意的話，有些建議想和您更深入請教。 再次感謝您的留言，對我們來說非常非常珍貴！ *如果對您比較方便的話，也可以透過官方 LINE 聯絡我們：https://go.clarymind.com/8rKFp6 – Clarymind Team🙌",
    date: "2025/3/21",
  },
  {
    rating: 5,
    name: "なあとや",
    title: "👍🏿👍🏿👍🏿",
    content: "能讓人知道自己到底為什麼會浪費那麼多時間在app上",
    reply: "感謝你的分享！知道 Clarymind 能為你帶來幫助，對我們來說意義非凡💛 你的鼓勵是最棒的回饋，也讓我們更有動力持續優化體驗。 如果你有任何想要加入的功能或建議，歡迎來信 contact@clarymind.com，期待有機會多了解你的想法！ – Clarymind Team🙌",
    date: "2025/3/10",
  },
  {
    rating: 5,
    name: "幸運蟋蟀",
    title: "嘗試使用中",
    content: "我想要幫助自己更有專注力，更好的產出，練習穩定自己",
    reply: "感謝你的分享，也很開心我們設計的初心有被感受到： 希望能和更多人一起拿回珍貴的專注力，有平靜而愉快的心情，發覺對自己最重要的事情，然後鼓勵自己持續地執行它💛 – Clarymind Team",
    date: "2025/3/15",
  },
  {
    rating: 5,
    name: "olivianiaza",
    title: "可愛的東西",
    content: "真有意外的有幫助 覺得自己不再alone的感覺",
    reply: "感謝你的留言鼓勵，我們很開心💛 我們會持續開發與「專注」和「健康」相關的應用功能，如果有任何建議，歡迎來信 contact@clarymind.com 讓我們知道🙏 （影侍和 Grumpi 也很開心有幫上忙！） – Clarymind Team",
    date: "2025/3/17",
  },
  {
    rating: 5,
    name: "yujie630",
    title: "真的能減少社群使用！",
    content: "很讚！！ 更新：想請問鑽石的作用是什麼呢？",
    reply: "感謝你的鼓勵和詢問💛 寶石原始的設計，是用數值的增加讓使用者感受到自己的進步 後來有越來越多用戶敲碗，希望寶石可以有更多用途，所以將會新增一些寶石才會看到的角色彩蛋哦 再次感謝您的鼓勵，我們會繼續進步的！ P.S. 如果方便用 LINE 【https://go.clarymind.com/8rKFp6】或 E-Mail 【contact@clarymind.com】聯絡我們，並留下聯絡方式，我們會在彩蛋上線的時候第一時間通知你🙏 – Clarymind Team",
    date: "2025/3/28",
  },
  {
    rating: 5,
    name: "班拜",
    title: "有趣又有用的專注app",
    content: "設計非常精美又有趣 在點進社群app前 給你很多的反思 到後來就真的沒有打開app了",
    reply: "感謝你的留言，給我們很大的動力，我們會努力讓體驗變得更好🙌 我們也會持續開發與「專注」和「健康」相關的應用功能，如果有任何功能許願，歡迎來信 contact@clarymind.com –Clarymind Team💛",
    date: "2025/3/23",
  },
  {
    rating: 5,
    name: "jaye1e",
    title: "第一次給app評價",
    content: "非常值得下載與訂閱！有效把時間從社交軟體拿回來，還能讓你反思使用社交軟體的必要性，真的設計的太好了！",
    reply: "非常感謝您的回饋，這是我們繼續努力很大的動力💓 ➡︎也和您說一聲，可以在 Clarymind Discord 查詢最新發佈的功能哦：https://discord.com/invite/H6McMYzJJJ ➡︎如果有任何使用問題，歡迎用 LINE 【https://go.clarymind.com/8rKFp6】或 E-Mail 【contact@clarymind.com】聯絡我們 我們會持續開發與「專注」和「健康」相關的應用功能，若有任何功能許願，也歡迎來信！ – Clarymind Team💛",
    date: "2025/4/1",
  },
  {
    rating: 4,
    name: "研究生日常",
    title: "😆",
    content: "目前使用下來確實有比較少拿起手機 但希望可以出一個中間版本的 對學生來說還是有一點小貴",
    reply: "很開心 Clarymind 對你有幫助💛 若有任何使用問題，歡迎用 LINE 【https://go.clarymind.com/8rKFp6】或 E-Mail 【contact@clarymind.com】聯絡我們。 App Store 留言會至少 2 天後才會收到，用其他方式聯絡可以提供更即時的協助 感謝你的留言鼓勵🙏",
    date: "2025/4/3",
  },
  {
    rating: 5,
    name: "Yas5246",
    title: "不錯",
    content: "很棒 但希望月費或年費能更平易近人些",
    reply: "感謝你的留言鼓勵，我們會努力開發更多和「專注」和「健康」相關的功能💛 如果有任何使用問題，或想申請免費線上導覽、了解 Clarymind 是否符合需求，歡迎聯絡 LINE 客服：https://go.clarymind.com/8rKFp6 再次感謝你的留言回饋！ – Clarymind Team 🙌",
    date: "2025/3/30",
  },
  {
    rating: 5,
    name: "chou po",
    title: "真的有用",
    content: "過去我基本每天都會滑IG，正常使用後一天可能只會滑一次或者不滑，因為他會問我要IG用的原因到底是什麼？有沒有其他替代方式，真的會給人一種反思平常自己反射性的動作。開發者真的好厲害。",
    reply: "謝謝你的稱讚和喜歡，對我們來說有非常大的意義 希望能和大家一起找回專注，完成更多事💛",
    date: "2025/4/5",
  },
  {
    rating: 3,
    name: "dhdgdjsj",
    title: "下載App之後不支援無痕模式",
    content: "不知道為什麼下載後沒辦法看到Safari的無痕模式⋯",
    reply: "和您說明原因：這是 iPhone 設計的機制。當使用進階設定「將特定網站的瀏覽器上鎖」功能時，Safari 瀏覽器會不能使用無痕模式。但如果只是上鎖社群 App，或使用 Chrome 瀏覽器，則還是可以使用瀏覽器的無痕功能。\n我們已經在「綁定網站設定頁面」和網站 FAQ ，新增此事的說明！感謝您的提醒🙏 因不同裝置和 iOS 版本有可能遇到不同的狀況，如果後續有任何使用問題，歡迎用 LINE 【https://go.clarymind.com/8rKFp6】或 E-Mail 【contact@clarymind.com】聯絡我們。App Store 留言通常至少 2 天後才會收到，用其他方式聯絡可以提供更即時的協助🙏",
    date: "2025/4/3",
  },
  {
    rating: 5,
    name: "SallyInTheHouse",
    title: "很好用的app，能夠幫助我們在開啟app的時候先想想，開啟app真正的目的為何，對於日常專注真的滿有幫助的！",
    content: "想提一個feature request: 可以做到針對某個app設定休息時間嗎？舉例來說，line只想要在平日上班時間被限制。感謝🙏",
    reply: "感謝你的鼓勵，我們好開心！希望能和你一起保持專注，完成更多事💓 針對留言提到的情境，請問是指希望【時間規劃】的休息時間設定，可以只選擇其中一個綁定的 App 適用嗎？ 感謝回饋，我們來評估一下🙏 我們很希望有機會能進一步請教你的想法，如果方便用 LINE 【https://go.clarymind.com/8rKFp6】或 E-Mail 【contact@clarymind.com】聯絡我們就太棒了。而且這樣如果這個功能上線，我們也能第一時間通知你💛",
    date: "2025/4/6",
  },
  {
    rating: 5,
    name: "奮鬥的少年",
    title: "讚喔👍",
    content: "不錯的應用程式",
    reply: "謝謝你的鼓勵，我們也會繼續奮鬥的！🙌",
    date: "2025/4/3",
  },
  {
    rating: 5,
    name: "TaliaaaC",
    title: "很有用🙂",
    content: "而且很可愛🥰",
    reply: "謝謝你的回饋💛 我們很努力讓「專注」和「減少社群使用」這件事變得有趣，希望讓更多人願意嘗試調整使用手機的方式 如果有任何功能或角色建議，歡迎來信 contact@clarymind.com，讓我們知道🥰",
    date: "2025/4/10",
  },
  {
    rating: 5,
    name: "Yoyosasasaa",
    title: "What a great and interesting app",
    content: "Great",
    reply: "Thank you for your encouragement. It means a lot to us.💛",
    date: "2025/4/5",
  },
  {
    rating: 5,
    name: "York0930",
    title: "拜託能不能買斷",
    content: "這個app實在是太棒了，但月費對學生來說太痛苦了😖",
    reply: "感謝你的五顆星鼓勵，Shado 很開心！ 採取訂閱制是因為 Clarymind 現在與未來的主要服務，圍繞 AI 功能打造，而 AI 會有依使用量計算的成本，所以需要採取訂閱的定價模式🥹🙏 如果訂閱前希望多了解 Pro 有哪些進階功能、可能對自己有幫助，歡迎用 LINE 【https://go.clarymind.com/8rKFp6】或 E-Mail【contact@clarymind.com】聯絡我們，我們有提供 1:1 線上 app 導覽服務 再次感謝你留言鼓勵🙏",
    date: "2025/4/11",
  },
  {
    rating: 5,
    name: "安啾Angel",
    title: "終於遇見你",
    content: "是個理想型的app 有相見恨晚的感覺，第一次試用感覺非常棒，連背景音樂都非常讓人舒適，與其他app 的等級差異很大，這是一個很值得下載的app",
    reply: "謝謝你的鼓勵，我們會繼續加油🫶我們會持續開發與「專注」和「健康」相關的應用功能，若有任何功能許願，歡迎隨時來信！ ▶︎也和您說一聲，可以在 Clarymind Discord 查詢最新發佈的功能：https://discord.com/invite/H6McMYzJJJ ▶︎如果有任何使用問題，歡迎用 LINE 【https://go.clarymind.com/8rKFp6】或 E-Mail【contact@clarymind.com】聯絡我們 – Clarymind Team💛",
    date: "2025/4/7",
  },
  {
    rating: 5,
    name: "馬鈴薯大將軍",
    title: "真的對專注很有效",
    content: "希望可以推出不同方案，例如無AI功能的買斷版本 和有AI功能的訂閱版本",
    reply: "感謝馬鈴薯大將軍的回饋💓 因 Clarymind 後續的產品方向，會試著導入新的 AI 功能；並且根據用戶訪談，大家也很喜歡既有 AI 為螢幕使用時間和冥想帶來的新體驗，甚至它是使用者訂閱的主要原因；以及Clarymind 是一個小型工作室，需要專注在一個產品上。 在這些考量下，Clarymind 需保持訂閱的定價模式，以確保團隊有能力持續更新及營運，推出更多與專注和健康相關的功能🙏 再次謝謝你溫暖的鼓勵！🙇‍♂️",
    date: "2025/4/10",
  },
  {
    rating: 5,
    name: "Jasmim lo7",
    title: "有中文正念引導",
    content: "有中文正念引導十分方便😍 這個程式的確大大減少了使用社群軟體的時間，並不是很強迫的，而是在你想要打開社群軟體之前，很溫柔的提醒你這是不是你真的需要的？我覺得當下多覺察這一下就可以很好的阻斷自動化打開軟體滑短影音的習慣了！！",
    reply: "謝謝你的鼓勵，我們會繼續加油的！若有任何功能許願，歡迎隨時來信！ ▶︎也和您說一聲，可以在 Clarymind Discord 查詢最新發佈的功能：https://discord.com/invite/H6McMYzJJJ ▶︎如果有任何使用問題，歡迎用 LINE 【https://go.clarymind.com/8rKFp6】或 E-Mail【contact@clarymind.com】聯絡我們 – Clarymind Team💛",
    date: "2025/4/15",
  },
  {
    rating: 5,
    name: "問世奇",
    title: "畫風我喜歡，看了心情就很好。",
    content: "藉由這個app讓自己更專心生活， 產值自然提升， 也更享受每日的時光， 以及悠閒和餘裕。",
    reply: "謝謝你的鼓勵🫶 設計師在角色設計上花了很多心思，App 的視覺會持續調整的！ 感謝你的溫暖留言讓我們充滿動力❤️‍🔥",
    date: "2025/4/14",
  },
  {
    rating: 5,
    name: "hans seal",
    title: "有用",
    content: "其實蠻有用的，也有一些根據",
    reply: "感謝你的留言，我們會努力讓體驗變得更好！ 如果有任何建議或功能許願，歡迎來信 contact@clarymind.com💛",
    date: "2025/4/17",
  },
  {
    rating: 5,
    name: "男人就是要被動",
    title: "建議提早上鎖，App可以有獎勵機制",
    content: "蠻好玩的也可以好好的把時間留給自己，這是一個有趣的概念對於使用手機不僅僅只是限制而是更多的思考",
    reply: "我們很喜歡這個點子，感謝您的建議，已經記錄下來了！🙌 ▶︎也和您說一聲，可以在 Clarymind Discord 查詢最新發佈的功能：https://discord.com/invite/H6McMYzJJJ ▶︎如果有任何使用問題，歡迎用 LINE 【https://go.clarymind.com/8rKFp6】或 E-Mail【contact@clarymind.com】聯絡我們 – Clarymind Team💛",
    date: "2025/4/15",
  },
  {
    rating: 5,
    name: "Asixwaaa",
    title: "第一款對我有效的app",
    content: "試用第一天就發現有大幅改善自己使用指定app的時間！ 到現在可以幾乎一天都不會想點開，真的很棒！ 訂閱制有些小貴，身為學生有些負擔不起⋯不然還會想要透過這款app戒掉更多指定app",
    reply: "非常感謝你的留言，我們會努力讓體驗和功能變得更好💛🙌",
    date: "2025/4/23",
  },
  {
    rating: 5,
    name: "永遠喜歡櫻井敦司",
    title: "祝你有美好的一天",
    content: "剛推出沒多久就訂閱了，可以限制 APP 使用時間和次數真的意外的很棒，特別是社群滑久了其實都會有點心浮氣躁，限制使用也算是幫助心靈健康 另外最近遇到一些挫折，很需要呼吸和冥想來幫助心情平靜，這款 APP 也能做到，真的幫了大忙🥺",
    reply: "太感謝您的留言鼓勵！！因為有早期訂閱用戶的支持，Clarymind 才有辦法一路做到今天😭 代表 Clarymind 團隊表達我們的感謝💞💓 我們會繼續研究「專注」、「個人健康」相關的功能和內容，如果有功能許願，也歡迎讓我們知道！ ▶︎也和您說一聲，可以在 Clarymind Discord 查詢最新發佈的功能：https://discord.com/invite/H6McMYzJJJ ▶︎如果有任何使用問題，歡迎用 LINE 【https://go.clarymind.com/8rKFp6】或 E-Mail【contact@clarymind.com】聯絡我們",
    date: "2025/4/23",
  },
  {
    rating: 3,
    name: "bobolin Yu",
    title: "服務迅速",
    content: "我有問題發mail詢問馬上有人很有耐心處理，推推100",
    reply: "很榮幸為您服務💓如果有其他問題，也歡迎隨時聯絡我們哦！",
    date: "2025/5/3",
  },
  {
    rating: 5,
    name: "到底有哪些暱稱還沒被用過啦",
    title: "太讚啦",
    content: "真的有夠讚的 希望能真的戒網癮",
    reply: "謝謝你的鼓勵！ （也謝謝你為了留言，還努力幫我們想暱稱！！！🤣❤️‍🔥） 如果有使用問題或功能許願，也歡迎隨時和我們聯絡🙌",
    date: "2025/5/1",
  },
  {
    rating: 5,
    name: "水瓶座的小兵粉",
    title: "👍",
    content: "非常好用 我真的成功戒掉無意義的一直開東西來看",
    reply: "非常感謝水瓶座的你的感人回饋💞💓 一起少滑社群，完成更多事🙌",
    date: "2025/5/5",
  },
  {
    rating: 5,
    name: "Bonnie_nii",
    title: "Useful",
    content: "I’ve tried many different methods, but none have helped me as much as this app does. The user interface is simple and cute, and it has allowed me to focus more every day. I’m so glad to see this change! Hope the language for AI mode and meditation can be set separately.",
    reply: "[update] 在最新的 Clarymind 版本，可以在「帳戶設定→語言設定」，把 Screen Time AI 和冥想引導的語言分別設定！如果有任何問題，歡迎隨時讓我們知道🙏 In the latest version of Clarymind, you can now set the languages for Screen Time AI and meditation guidance separately under Account → Language. If you have any questions, feel free to let us know🙏 ---- Thank you so much for your feedback. It means a lot to us 😭 We’ve received your suggestion. We're currently planning to make it possible to modify the language of guided meditation directly on the interface, and we’ll update this comment to let you know once it’s ready. If you have any questions or feature requests, feel free to email us at contact@clarymind.com💛",
    date: "2025/5/6",
  },
  {
    rating: 4,
    name: "Kilito☆",
    title: "希望有的買斷制的版本",
    content: "我知道ai使用是按token 計價因此必須有月費制，不知道能不能出沒有ai版本但有有呼吸模式但可以無限制增加app和其他功能的買斷制方案",
    reply: "感謝 Kilito 的留言，也非常感謝在提供想法的同時，為我們設想🤍 和 Kilito 說明： ・因 Clarymind 後續的產品方向，會持續試著導入新的 AI 功能；並且根據用戶訪談，大家也很喜歡既有 AI 為螢幕使用時間和冥想帶來的新體驗，甚至它是使用者訂閱的主要原因。同時， Clarymind 是一個小型工作室，需要專注在一個產品上。 最後，對於已購買的舊戶，如果後續又推出不同版本，可能會有升級或降級的需求，然而 App Store 的購買，開發者沒有百分百的掌控權，預期會造成一些用戶困擾。 基於以上這些考量，Clarymind 期望專注在一個產品上，確保團隊有能力持續更新及營運，推出更多與專注和健康相關的功能🙏",
    date: "2025/5/22",
  },
  {
    rating: 5,
    name: "ＷayneHusky",
    title: "手機戒斷症",
    content: "手機一打開就會不知覺無限使用，時間都被手機偷走了，就跟大麻一樣，希望這個能讓我保持原始人的狀態",
    reply: "Clarymind 就是從想解決自己遇到的這個問題開始的🥹希望和 ＷayneHusky 一起保持專注，完成更多事💛",
    date: "2025/6/6",
  },
  {
    rating: 5,
    name: "鮭助桑",
    title: "👍",
    content: "超好用 但不知道寶石可以幹嘛",
    reply: "感謝你的鼓勵和詢問💛 寶石原始的設計，是用數值的增加讓使用者感受到自己的進步。後來有越來越多用戶敲碗，希望寶石可以有更多用途，所以將會新增一些寶石才會看到的角色彩蛋哦 再次感謝你的鼓勵，我們會繼續進步的！ P.S. 如果方便用 LINE 【https://go.clarymind.com/8rKFp6】或 E-Mail 【contact@clarymind.com】聯絡我們，並留下聯絡方式，我們會在彩蛋上線的時候第一時間通知你🙏 – Clarymind Team",
    date: "2025/6/17",
  },
  {
    rating: 5,
    name: "ghkcsehcxf",
    title: "靈魂拷問的新功能很讚",
    content: "靈魂拷問比貓貓還有用，畢竟貓貓不能摸，但還在習慣app中，不知道鑽石可以做什麼，還有白噪音也幾個有點假，像風跟雨聲的部分音質有點粗，",
    reply: "您好，同時間有收到一封應該是您寫的 E-Mail 來信，我們當天有回信給您，希望有機會邀請您參與我們線上使用者訪談🙏 非常感謝資訊，讓我們有機會調整，也希望有機會和您進一步請教想法🙇‍♂️",
    date: "2025/6/6",
  },
  {
    rating: 5,
    name: "Maggie0112",
    title: "非常推薦",
    content: "身為重度使用手機的用戶，確實有效的改變了我的習慣",
    reply: "非常感謝您的鼓勵，我們會繼續加油的💛🥹 如果有任何使用問題或功能許願，都歡迎來信 contact@clarymind.com ！您的留言是我們明天颱風天準時上班的動力💪",
    date: "2025/6/23",
  },
  {
    rating: 5,
    name: "yhjr_moli_",
    title: "買了付費版",
    content: "一看到這個app就直接買了付費版，使用幾天下來覺得非常值得！我是115學測考生，clarymind確實讓我減少使用很多不必要的app，一天的時間多了好多❤️最棒的功能是打開某些程式可以跳轉到別的程式，我把遊戲那些的都設置會跳轉到待辦事項，解決了每次一休息就忘記還有很多事還沒做完的問題。反正，問就是直接買付費版！很讚大推👍",
    reply: "非常感謝您的鼓勵💛💛💛我們會繼續加油的！ 如果有任何使用問題或功能許願，都歡迎來信 contact@clarymind.com 哦 您的留言給我們滿滿的動力💖Shado, Grumpi, 國王一起深深一鞠躬！",
    date: "2025/6/13",
  },
  {
    rating: 5,
    name: "Albee hau",
    title: "真的非常喜歡",
    content: "我覺得很好用",
    reply: "感謝您的留言鼓勵，我們會繼續加油的💛 Grumpi 和我們一起鞠躬感謝您 🐈🐈🐈 如果有任何使用問題或功能許願，都歡迎來信 contact@clarymind.com 哦！",
    date: "2025/7/16",
  },
  {
    rating: 1,
    name: "MHJ from Taiwan",
    title: "無法買斷",
    content: "那就不買了😠",
    reply: "不買沒關係，不要生氣嘛🥺 因為我們有 AI 功能，服務的成本會一直往上加，所以無法提供買斷🙏",
    date: "2025/8/3",
  },
  {
    rating: 5,
    name: "呂芃芃",
    title: "使用",
    content: "很好！超棒",
    reply: "太感謝芃芃的回饋💛💛💛 如果有任何問題或功能許願，歡迎隨時透過 LINE 【https://go.clarymind.com/8rKFp6】或 E-Mail 【contact@clarymind.com】聯絡我們哦！祝您有美好的一天💖",
    date: "2025/7/27",
  },
  {
    rating: 5,
    name: "MingYangTWN",
    title: "有效降低手機成癮時間",
    content: "透過溫和的反思、提問、建議讓人重拾意志力，少用社群，多善用手機的生產力和學習力工具，大推！",
    reply: "感謝 MingYang 的留言🥹💛我們會繼續加油的！ 如果有任何問題或功能許願，歡迎隨時透過 LINE 【https://go.clarymind.com/8rKFp6】或 E-Mail 【contact@clarymind.com】聯絡我們！祝您有美好的一天🌿",
    date: "2025/8/6",
  },
  {
    rating: 5,
    name: "ㄹㅅㄹㅍ 💛",
    title: "反正超有用你各位都來用拜託🫠",
    content: "就是呃呃呃就是真的會有種讓你要認真專注的感覺（？ 反正用了就知道🙂‍↕️",
    reply: "嗚嗚嗚太感人了，謝謝你的熱情推薦😭😍",
    date: "2025/8/4",
  },
  {
    rating: 5,
    name: "chooooooooooooolll",
    title: "真的很棒！",
    content: "每次想打開都會多思考幾次 然後最後放棄打開 去做呼吸練習🩷🩷🩷",
    reply: "一起找回生活有餘裕的感覺，完成更多想要做的事🩷🩷🩷 感謝您的留言鼓勵，對我們有很大的意義🙏如果有任何使用問題或功能許願，都歡迎來信 contact@clarymind.com 哦！",
    date: "2025/8/8",
  },
  {
    rating: 5,
    name: "hagoloqpuedo",
    title: "Sooooo helpful",
    content: "I wish they could allow a link to study the Book of Mormon!!",
    reply: "Thanks so much for your feedback💛 Any websites or apps you’d recommend?",
    date: "2025/8/22",
  },
  // {
  //   rating: 5,
  //   name: "(◐‿◑)(◐‿◑)(◐‿◑)(⁎⁍̴̛ᴗ⁍̴̛⁎)",
  //   title: "欸是付費的 蠻不錯的(◐‿◑)",
  //   content: "付費後就會下定決心要好好用這個應用程式 不浪費錢 時間就是金錢 就是可以便宜個500塊嗎 對我來說壓力大",
  //   reply: "這裡有完整的圖文介紹給您參考💛【 https://go.clarymind.com/oUB039】 如果對您有幫助的話，也歡迎聯絡 Clarymind LINE 客服【https://go.clarymind.com/8rKFp6】，預約 1:1、15-30 分鐘的線上 app 導覽，可以快速了解 app 適合您的設定💪",
  //   date: "2025/8/15",
  // },
  {
    rating: 4,
    name: "Patates douces 99",
    title: "Add more practical features",
    content: "First of all, thank you for creating this amazing app, it has significantly reduced my social media usage time. I would 100% recommend it to anyone who are addicted to social media without even realizing it. However, I personally hope to see more practical features added. After using it for a few weeks, I found that the only functions I actually use are the app lock and the reflection reminder before usage. Other features like music, mindfulness meditation or breathing exercises are unnecessary for people who don’t need them. In fact, if you simply want to relax or occasionally use social media, you’ll likely skip these features entirely. If possible, hope you can add functions like calendar or to do lists. When we try to open a social media app, instead of just promoting a reflection ( “why do you want to use it?”) it can also remind us of any pending tasks we still need to complete — adding resistance to opening social media apps. I also hope to a feature like performance reports or usage frequency comparisons. So we can better understand our actual usage patterns and improve our behavior. Thank you again, and I look forward to hearing back from you.",
    reply: "Thank you for your feedback💛💛💛 We really appreciate your suggestions, and we’re exploring how to implement features like to-do lists and performance reports. Would you be interested in joining a 15–30 minute online user interview with us? If so, you can reach us on LINE here: 【https://go.clarymind.com/8rKFp6】. We’ll send you a small thank-you gift for your time🫶",
    date: "2025/8/16",
  },
  {
    rating: 5,
    name: "上帝的孩子2",
    title: "讓人擺脫這個資訊爆炸的時代",
    content: "它強制你思考與慢下來，我覺得幫助很大",
    reply: "讓我們一起少滑一點，多思考、多體驗、多完成一些想做的事💛",
    date: "2025/8/21",
  },
  {
    rating: 5,
    name: "魯魯溜溜",
    title: "寶石跟經驗值可以幹嘛？",
    content: "雖然有點貴，但真的有讓我的螢幕使用時間大幅下降，另外，寶石跟檢驗值到底是拿來做什麼的啊？",
    reply: "感謝你的鼓勵和詢問💛 寶石原始的設計，是用數值的增加讓使用者感受到自己的進步。後來有越來越多用戶敲碗，希望寶石可以有更多用途，所以將會新增一些寶石才會看到的角色彩蛋！ 再次感謝你的鼓勵，我們會繼續進步的！ P.S. 如果方便用 LINE 【https://go.clarymind.com/8rKFp6】或 E-Mail 【contact@clarymind.com】聯絡我們，並留下聯絡方式，我們會在彩蛋上線的時候第一時間通知你🙏 – Clarymind Team",
    date: "2025/8/22",
  },
  {
    rating: 5,
    name: "Vhgfgfgfv",
    title: "超棒的app",
    content: "我本身有ADHD,常常手機拿起來就是doom scrolling 一整天 十分痛苦卻又無法自拔 下載了之後 把多出來的時間拿來看電子書 一個多月的時間看了四本書 真的很感謝開發團隊 這對我來說意義重大 感覺人生又有了希望 謝謝你們開發這個app讓世界變得更好❤️",
    reply: "非常感謝您和我們分享使用的經驗和想法，這給予團隊很大的鼓勵❤️ 如果有任何功能許願，歡迎來信 contact@clarymind.com 讓我們知道🥰",
    date: "2025/8/23",
  },
  {
    rating: 5,
    name: "she83919",
    title: "很好",
    content: "希望能推出睡眠時間控制，到睡覺時間整個手機可以鎖住",
    reply: "非常感謝您的回饋💛💛💛請問您有嘗試過 Clarymind 的「深度專注時間」嗎？如果仍有特定情境沒有被滿足的話，歡迎用 LINE 【https://go.clarymind.com/8rKFp6】聯絡我們，我們來研究能為此做什麼🙏",
    date: "2025/8/24",
  },
];